import { Breakpoints } from 'rn-responsive-styles/lib/providers/BreakpointsProvider';

const EXTRA_LARGE = 1920;
const LARGE = 1280;
const MEDIUM = 768;
const SMALL = 320;

const BREAKPOINTS: Breakpoints = [EXTRA_LARGE, LARGE, MEDIUM, SMALL];

export { BREAKPOINTS };
